import formatHelper from '@Common/Helpers/FormatHelper';
import timeHelper, { dateTimeInterval } from '@Common/Helpers/TimeHelper';
import { DateTimeInterval } from '@InstanceFactory';

export class DataTimeIntervalHelper {
    private static readonly intervalSplitter = '|';

    public static toString(interval: DateTimeInterval): string {
        if (!interval) {
            return null;
        }
        return formatHelper.dateTimeToString(interval.from) + DataTimeIntervalHelper.intervalSplitter + formatHelper.dateTimeToString(interval.to);
    }

    public static format(interval: DateTimeInterval, dateTimeFormatName: string): string {
        const fromDateStr = formatHelper.formatDateTime(interval.from, dateTimeFormatName);
        const toDateStr = formatHelper.formatDateTime(interval.to, dateTimeFormatName, true);
        return `${fromDateStr} - ${toDateStr}`;
    }

    public static parse(stringValue: string): DateTimeInterval {
        const items = stringValue.split(DataTimeIntervalHelper.intervalSplitter);
        let from = new Date();
        let to = new Date();
        if (items.length === 2) {
            from = timeHelper.dateTimeFromString(items[0]);
            to = timeHelper.dateTimeFromString(items[1]);
        }
        return dateTimeInterval(from, to);
    }
}
